import React from 'react';
import CodeIndexPage from './CodeIndexPage';


const Index = () => {
  return (
    <div className="">
      <CodeIndexPage/>
    </div>
  );
};

export default Index;
